import { $t } from '@/plugins/i18n'
import { ref } from 'vue'
import type { ToastState, ToastMethods } from '@/types/toast.types'

const state = ref<ToastState>({
  show: false,
  type: 'success',
  title: '',
  description: '',
  sectionTag: 'global-toast'
})

export function useToast(): { state: typeof state } & ToastMethods {
  const showToast = (options: Omit<ToastState, 'show'>) => {
    state.value = {
      ...options,
      show: true
    }
  }

  const hideToast = () => {
    state.value.show = false
  }

  const showSuccess = (description: string, title?: string, sectionTag?: string) => {
    if (!title) {
      title = $t('app.common.messages.success')
    }
    showToast({ type: 'success', title, description, sectionTag })
  }

  const showError = (description: string, title?: string, sectionTag?: string) => {
    if (!title) {
      title = $t('app.common.messages.error.title')
    }
    showToast({ type: 'error', title, description, sectionTag })
  }

  const showWarning = (description: string, title?: string, sectionTag?: string) => {
    if (!title) {
      title = $t('app.common.messages.warning')
    }
    showToast({ type: 'warning', title, description, sectionTag })
  }

  const showInfo = (description: string, title?: string, sectionTag?: string) => {
    if (!title) {
      title = $t('app.common.messages.info')
    }
    showToast({ type: 'info', title, description, sectionTag })
  }

  return {
    state,
    showToast,
    hideToast,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
}
